import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/es/styles/withStyles";
import { changePageHeader } from "../app/AppActions";
import { Translate } from "react-redux-i18n";
import settingsStyles from './jss/SettingsStyles';
import { getSettings, updateSettings } from './SettingsActions'
import print from '../../assets/img/printer-1.png'
import share from '../../assets/img/share-2.png'
import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import Link from "react-router-dom/es/Link";

const MAPPING_VALUES = {
    "disable-print": false,
    "enable-print": true,
    "disable-share": false,
    "enable-share": true
}


class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            printValue: '',
            shareValue: ''
        }
    }

    componentDidMount() {
        const { changePageHeader } = this.props;
        changePageHeader("Settings");
        this.props.getSettings()
    }

    componentWillReceiveProps(nextProps) {
        let {settings: {isPrint, isShare, needUpdate}, user} = nextProps;
        if (needUpdate) {
            this.props.getSettings(user.email)
        }
        if(isPrint) {
            this.setState({ printValue: 'enable-print' });
        }else {
            this.setState({ printValue: 'disable-print' });
        }

        if(isShare) {
            this.setState({ shareValue: 'enable-share' });
        }else {
            this.setState({ shareValue: 'disable-share' });
        }
    }

    handleSelect = (event) => {
        if(event.target.value  === 'disable-print' || event.target.value  === 'enable-print') {
            this.setState({ printValue: event.target.value });
        }
        if(event.target.value  === 'disable-share' || event.target.value  === 'enable-share') {
            this.setState({ shareValue: event.target.value });
        }
        
    }

    handleSubmit = (e) => {
        e.preventDefault()
        this.props.updateSettings({email: this.props.user.email, values: {isShare: MAPPING_VALUES[this.state.shareValue], 
            isPrint: MAPPING_VALUES[this.state.printValue]}})
    }

    render() {
        const { classes, app, settings: {fetching, isPrint, isShare} } = this.props;
        return (
            fetching ? <div style={{textAlign: 'center'}}><CircularProgress size={45} /></div> :
            <div id='settings'>
                <div className={classes.pageTitle}>
                    Settings
                </div>
                {/* <form onSubmit={this.handleSubmit}>
                <div className={classes.settingsItem}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <img className={classes.icon} src={print} alt="print" />
                        <span style={{marginLeft: '10px'}}>Disable Print</span>
                    </div>
                    
                    <select onChange={this.handleSelect} defaultValue={this.state.printValue} className={classes.select}>
                            <option value='disable-print'>NO</option>
                            <option value='enable-print' selected={isPrint}>YES</option>
                    </select>
                </div>
                <div className={classes.settingsItem}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <img className={classes.icon} src={share} alt="print" />
                        <span style={{marginLeft: '10px'}}>Disable Share</span>
                    </div>
                    <select onChange={this.handleSelect} defaultValue={this.state.shareValue} className={classes.select}>
                            <option value='disable-share'>NO</option>
                            <option value='enable-share' selected={isShare}>YES</option>
                    </select>
                </div>
                <input type="submit" value="Save" style={{    width: '122px',
                        color: '#FFFFFF',
                        background: '#1B23ED',
                        boxShadow: '4px 4px 18px 1px rgba(27, 97, 237, 0.35)',
                        borderRadius: '3px', outline: 'none', border: 'none', padding: '5px 10px', marginTop: '10px'}} />
                </form> */}
                <div className={classes.deleteAccSetings}>
                    <Link to='/delete-account' style={{textDecoration: 'none'}}>
                        <span style={{
                        width: '122px',
                        color: 'red',
                        border: '1px solid red',
                        background: '#fff',
                        boxShadow: '4px 4px 18px 1px rgba(27, 97, 237, 0.35)',
                        borderRadius: '3px', outline: 'none', padding: '7px 50px', marginTop: '10px'}}>Delete Account</span>
                    </Link>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ app, settings, user }) => ({ app, settings, user });

const mapDispatchToProps = dispatch => bindActionCreators({changePageHeader, getSettings, updateSettings }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(settingsStyles)(Settings));



// WEBPACK FOOTER //
// ./src/containers/settings/Settings.js